
export const enum Level {
  ERROR = "ERROR",
  INFO = "INFO",
}


export class MessageTrayData {
  timestamp: Date;
  logLevel: Level;
  message: any;
}
